/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Token model module.
 * @module model/Token
 * @version 0.0.1
 */
class Token {
    /**
     * Constructs a new <code>Token</code>.
     * @alias module:model/Token
     */
    constructor() { 
        
        Token.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Token</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Token} obj Optional instance to populate.
     * @return {module:model/Token} The populated <code>Token</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Token();

            if (data.hasOwnProperty('activationcode')) {
                obj['activationcode'] = ApiClient.convertToType(data['activationcode'], 'String');
            }
            if (data.hasOwnProperty('expiry')) {
                obj['expiry'] = ApiClient.convertToType(data['expiry'], 'String');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('label_full')) {
                obj['label_full'] = ApiClient.convertToType(data['label_full'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Token</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Token</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['activationcode'] && !(typeof data['activationcode'] === 'string' || data['activationcode'] instanceof String)) {
            throw new Error("Expected the field `activationcode` to be a primitive type in the JSON string but got " + data['activationcode']);
        }
        // ensure the json data is a string
        if (data['expiry'] && !(typeof data['expiry'] === 'string' || data['expiry'] instanceof String)) {
            throw new Error("Expected the field `expiry` to be a primitive type in the JSON string but got " + data['expiry']);
        }
        // ensure the json data is a string
        if (data['label'] && !(typeof data['label'] === 'string' || data['label'] instanceof String)) {
            throw new Error("Expected the field `label` to be a primitive type in the JSON string but got " + data['label']);
        }
        // ensure the json data is a string
        if (data['label_full'] && !(typeof data['label_full'] === 'string' || data['label_full'] instanceof String)) {
            throw new Error("Expected the field `label_full` to be a primitive type in the JSON string but got " + data['label_full']);
        }

        return true;
    }


}



/**
 * @member {String} activationcode
 */
Token.prototype['activationcode'] = undefined;

/**
 * @member {String} expiry
 */
Token.prototype['expiry'] = undefined;

/**
 * @member {String} label
 */
Token.prototype['label'] = undefined;

/**
 * @member {String} label_full
 */
Token.prototype['label_full'] = undefined;






export default Token;

